import { NextRouter } from 'next/router';
import { isAccountAuthPath } from './accountAuth';
import { Account } from '@Types/account';

type RedirectParams = {
  loggedIn: boolean;
  account: Account;
  url: string;
  loaded: boolean;
  router: NextRouter;
};

const cancelRouting = (router: NextRouter, url: string) => {
  // See https://github.com/zeit/next.js/issues/2476
  router.events.emit('routeChangeError');
  router.push(url);
  throw `routeChange aborted. This error can be safely ignored - https://github.com/zeit/next.js/issues/2476.`;
};

export const routeChangeRedirect = ({ loaded, loggedIn, url, account, router }: RedirectParams) => {
  if (loaded) {
    if (!loggedIn && isAccountAuthPath(url)) {
      cancelRouting(router, '/login');
    }
  }
};
